/**
 * @generated SignedSource<<e85ebd0859e41b4c7c84cba98a08e891>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBuyItNowButton_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedBuyItNowButton_user";
};
export type PdpSharedBuyItNowButton_user$key = {
  readonly " $data"?: PdpSharedBuyItNowButton_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBuyItNowButton_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBuyItNowButton_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "27ad8f3e775d136f9bc00fa3ffc77c3e";

export default node;
